import React from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import "../index.css";

/**
 * [BasicInput description]
 * @param {[string]} type [Type of the input element - Default: text]
 * @param {[string]} theme [The theme of the component - default: light]
 * @param {[string]} styleVariant [Used to represent colored interface elements for a user - default: primary]
 * @param {[string]} placeholder [The short hint displayed in the input before the user enters a value - default: "Type Here"]
 * @param {[any]} ...props [Other valid props for MUI Input]
 * @returns {[object]} [Returns the badge component]
 */
// MUI Input outlined
const BasicInput = (props) => {
  const {
    type = "text",
    theme = "light",
    placeholder = "Type Here",
    styleVariant = "primary",
    ...remaining
  } = props;

  const CssTextField = withStyles({
    root: {
      fontFamily: "var(--fontFamily)",
      borderRadius: "var(--border-radius)",
      boxSizing: "border-box",
      backgroundColor: `var(--${styleVariant}-textfield-bgcolor-${theme})`,
    },
  })(TextField);

  const inputStyles = makeStyles({
    typographyStyle: {
      fontFamily: "var(--fontFamily)",
      "& .MuiOutlinedInput-root": {
        color: `var(--${styleVariant}-textfield-bgcolor-${theme})`,
        border: "1px solid currentColor",
      },
      "& .MuiInputBase-input": {
        fontFamily: "var(--fontFamily)",
        fontSize: "var(--font-size-XS)",
        color: `var(--${styleVariant}-textfield-color-${theme})`,
        padding: "var(--textfield-padding)",
        "&::placeholder": {
          color: `currentColor`,
        },
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: "0px",
      },
    },
  });
  const classes = inputStyles();

  return (
    <CssTextField
      type={type}
      className={classes.typographyStyle}
      placeholder={placeholder}
      {...remaining}
    />
  );
};

BasicInput.propTypes = {
  type: PropTypes.string,
  placeholder: PropTypes.string,
  theme: PropTypes.oneOf(["light", "dark"]),
  styleVariant: PropTypes.oneOf(["primary", "secondary"]),
};

export default BasicInput;
